/* <review-marquee>: endless row of reviews. Clones the group once so the loop is seamless,
   and wires up the pause button. */
(function () {
  'use strict';

  if (customElements.get('review-marquee')) return;

  class ReviewMarquee extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('reviews__viewport--marquee')) return;
      var track = this.querySelector('.reviews__track');
      var group = track.querySelector('.reviews__group');
      if (!group || track.children.length > 1) return;
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
      track.appendChild(clone);

      var section = this.closest('.reviews');
      var pause = section && section.querySelector('[data-reviews-pause]');
      if (!pause) return;
      var label = pause.querySelector('[data-pause-label]');
      var strings = window.Atelier.strings;
      var self = this;
      pause.addEventListener('click', function () {
        var paused = pause.getAttribute('aria-pressed') !== 'true';
        pause.setAttribute('aria-pressed', String(paused));
        self.classList.toggle('is-paused', paused);
        if (label) label.textContent = paused ? strings.resumeReviews : strings.pauseReviews;
      });
    }
  }

  customElements.define('review-marquee', ReviewMarquee);
})();
